import { render, staticRenderFns } from "./Parcours.vue?vue&type=template&id=553cbd50&"
import script from "./Parcours.vue?vue&type=script&lang=js&"
export * from "./Parcours.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports